@if (photoUrls().length) {
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-px-3 tw-py-1.5 tw-rounded-2 tw-bg-green-20">
    <span class="tw-flex tw-items-center tw-gap-1">
      <cs-icon [iconName]="checkIcon" class="tw-w-5 tw-h-5 tw-text-green-400"></cs-icon>
      <span class="tw-text-200 tw-text-green-400">{{ label() }}</span>
    </span>
    @if (isSinglePhoto()) {
      <button type="button"
        data-testid="quiz-uploaded-photo-thumbnail"
        class="tw-w-8 tw-h-8 tw-m-0 tw-p-0 tw-min-w-0 tw-rounded-full tw-overflow-hidden tw-bg-gray-400 tw-cursor-pointer"
        (click)="onOpen()">
        <img class="tw-w-full tw-h-full tw-object-cover" [src]="photoUrls()[0]" alt="">
      </button>
    } @else {
      <span class="tw-flex tw-items-center tw-gap-0.75">
        @for (photoUrl of photoUrls(); track photoUrl) {
          <span data-testid="quiz-uploaded-photo-thumbnail"
            class="tw-w-8 tw-h-8 tw-rounded-full tw-overflow-hidden tw-bg-gray-400">
            <img class="tw-w-full tw-h-full tw-object-cover" [src]="photoUrl" alt="">
          </span>
        }
      </span>
    }
  </div>
}
